
































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EditBlock from '@/views/CRUD/Edit.vue';
import TitleReturn from '@/components/TitleReturn.vue';
import InputBase from '@/components/input/Input.vue';
import SelectCustom from '@/components/select/SelectCustom.vue';
import MultiSelect from '@/components/multiselect/Multiselect.vue';
import CheckboxBase from '@/components/checkbox/Checkbox.vue';
import ImageInputEntity from '@/components/image-input/ImageInputEntity.vue';
import ErrorField from '@/components/form/ErrorField.vue';
import BaseButton from '@/components/buttons/BaseButton.vue';
import { getById, updateEntity } from '@/api/crud';
import { CatalogKind, Choice, choices, catalogPath, titles, errorMessage } from '@/api/analysisCalculator';
import { Photo } from '@/types/common';
import { API_URL } from '@/utils/constants';
import ResponseHandlerModule from '@/store/modules/responseHandler';

@Component({ components: { EditBlock, TitleReturn, InputBase, SelectCustom, MultiSelect, CheckboxBase, ImageInputEntity, ErrorField, BaseButton } })
export default class CalculatorEdit extends Vue {
    @Prop({ required: true }) kind!: CatalogKind;
    values: Record<string, any> | null = null;
    photo: Photo | null = null;
    categories: Choice[] = [];
    selectedCategories: Choice[] = [];
    materials: Choice[] = [];
    material: Choice | null = null;
    loading = false;
    saving = false;
    error = '';
    errors: Record<string, string> = {};
    loadVersion = 0;
    get title() { return this.values?.name || titles[this.kind]; }
    back() { if (!this.saving) this.$router.push({ name: `analysis-calculator-${this.kind}` }); }
    @Watch('$route.fullPath', { immediate: true }) async load() {
        const version = ++this.loadVersion;
        this.loading = true; this.error = ''; this.values = null; this.errors = {};
        try {
            const [values, categories, materials] = await Promise.all([
                getById(catalogPath(this.kind), this.$route.params.id),
                this.kind === 'analyses' ? choices('categories') : Promise.resolve([]),
                this.kind === 'analyses' ? choices('biomaterials') : Promise.resolve([]),
            ]);
            if (version !== this.loadVersion) return;
            this.categories = categories;
            this.materials = [{ id: 0, value: 'Не требуется' }, ...materials];
            this.selectedCategories = categories.filter(item => values.categories.includes(item.id));
            this.material = this.materials.find(item => item.id === values.biomaterial) || this.materials[0];
            this.photo = values.icon ? { id: values.id, src: new URL(values.icon, new URL(API_URL, window.location.origin)).href } as Photo : null;
            this.values = values;
        } catch (error) { if (version === this.loadVersion) this.error = errorMessage(error); }
        finally { if (version === this.loadVersion) this.loading = false; }
    }
    async save() {
        if (this.saving || !this.values) return;
        this.saving = true; this.error = ''; this.errors = {};
        try {
            const data: Record<string, any> = { ...this.values, categories: this.selectedCategories.map(item => item.id), biomaterial: this.material?.id || null };
            delete data.icon;
            if (this.photo?.file) data.icon = this.photo.file;
            data.removeIcon = !this.photo && !!this.values.icon;
            await updateEntity(catalogPath(this.kind), this.$route.params.id, data);
            ResponseHandlerModule.showNotify({ message: 'Изменения сохранены', type: 'ok' });
            this.saving = false; this.back();
        } catch (error) {
            this.errors = error.response?.data?.errors?.fields || {};
            this.error = Object.keys(this.errors).length ? 'Проверьте заполнение полей.' : errorMessage(error);
        } finally { this.saving = false; }
    }
    beforeDestroy() { this.loadVersion++; if (this.photo?.file) URL.revokeObjectURL(this.photo.src); }
}
